import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons'
import { Link } from 'react-router-dom'
import styles from './EmptyState.module.scss'

interface Props {
  link?: {
    text: string
    href: string
  }
  text: string
}

export const EmptyState = ({ text, link }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <div className={styles.icon}>
          <FontAwesomeIcon icon={faGraduationCap} />
        </div>
      </div>
      <div className={styles.text}>{text}</div>
      {link && (
        <Link className={styles.link} to={link.href}>
          {link.text}
        </Link>
      )}
    </div>
  )
}
